import { FinanceOperationsAddFormRequestType } from "@/form/finance/finance_operations/FinanceOperationsAddForm.types";
import {IFinanceOperationsRepository} from "@/repository/finance/finance_operations/FinanceOperationsRepository.types";
import {IFinanceOperations, IFinanceOperationsListItem, FinanceOperationsResponseType} from "@/entity/finance/finance_operations/financeOperations.types";
import Api from "@/repository/api";
import FinanceOperations from "@/entity/finance/finance_operations/financeOperations";
import {FinanceOperationsGeneralRequestType} from "@/form/finance/finance_operations/FinanceOperationsGeneral.types";
import qs from "qs";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {ResponseDataType} from "@/form/form.types";

export class FinanceOperationsRepository implements IFinanceOperationsRepository {
    async fetchAll(data?: FormData): Promise<IFinanceOperations> {
        const response = await Api.get(`/finance/operations/get`, {params: data, paramsSerializer: function paramsSerializer(params) {
            return new URLSearchParams(params).toString()
        }});
        const responseData = response.data as FinanceOperationsResponseType;
        return new FinanceOperations(responseData);
    }
    async fetchData(data: PaginationRequestType): Promise<IFinanceOperationsListItem> {
        const response = await Api.get(`/finance/operations/get`, {params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        const responseData = response.data as FinanceOperationsResponseType;
        return new FinanceOperations(responseData).data[0];
    }
    async import(data: FormData): Promise<ResponseDataType> {
        const response = await Api.post(`/finance/operations/import`, data);
        const responseData = response.data;
        return responseData;
    }
    async export(data?: FormData): Promise<ResponseDataType> {
        const response = await Api.get(`/finance/operations/export`, {params: data, paramsSerializer: function paramsSerializer(params) {
            return new URLSearchParams(params).toString()
        }});
        const responseData = response.data;
        return responseData;
    }
    async create(data: FinanceOperationsAddFormRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/finance/operations/create`, data);
        const responseData = response.data;
        return responseData;
    }
    async update(data: FinanceOperationsGeneralRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/finance/operations/update`, data);
        const responseData = response.data;
        return responseData;
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/finance/operations/delete`, data);
        const responseData = response.data;
        return responseData;
    }
}
